import React, { ChangeEvent, FC, useState } from 'react'
import { InputGroup, Box, Button } from '@chakra-ui/react'
import CurrencyInput from 'react-currency-input-field'
import theme from '../../styles'
import { Icon } from '../icon'
import { useDispatch, useSelector } from 'react-redux'
import { addAnswer, selectAnswers } from '../../state'
import { Answers, Steps } from '../../state/interfaces'

export interface InputSavingsProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}

export const InputSavings: FC<InputSavingsProps> = ({ onChange, name }) => {
  const dispatch = useDispatch()
  const prefix = '$ '
  const [value, setValue] = useState<string>('')
  const answers: Answers = useSelector(selectAnswers)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    setValue(event.target.value.replace(/[^\d.]/, ''))
  }

  const handleOnBlur = () => {
    if (Number(value) > 0) {
      setValue(Number(value).toFixed(2))
    }
  }

  const setSavingsAnswer = () => {
    if (answers['current-monthly-payment']) {
      const currentMonthlyPayment = Number(answers['current-monthly-payment'])
      const desiredPaymentValue = Number(value.replace(/[^\d.]/, ''))
      let difference = currentMonthlyPayment - desiredPaymentValue
      if (difference < 0) {
        difference = 0
      }
      dispatch(
        addAnswer({
          stepId: Steps.SAVINGS_PERCENT,
          answerIds: [((difference / currentMonthlyPayment) * 100).toFixed(2)],
          hidden: true,
        }),
      )
    }
  }

  return (
    <Box marginY={8} width={'full'} maxWidth={350}>
      <InputGroup
        display="grid"
        alignItems="center"
        outline="none"
        borderRadius="md"
        variant="none"
        fontSize={22}
        paddingLeft={4}
        layerStyle={theme.LayerStyles.INPUT}
      >
        <CurrencyInput
          prefix={prefix}
          name={name}
          id="currencyInput"
          data-number-to-fixed="2"
          data-number-stepfactor="100"
          value={value}
          placeholder="$ 0.00"
          onChange={handleChange}
          onBlur={handleOnBlur}
          allowDecimals
          disableAbbreviations
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter' && value) {
              ev.preventDefault()
              onChange && onChange([value.toString()])
            }
          }}
          autoFocus
        />
        {value && (
          <Button
            role={'button'}
            position="absolute"
            borderRadius="md"
            layerStyle={theme.LayerStyles.BTN_INPUT_PILL}
            onClick={() => {
              setSavingsAnswer()
              onChange && onChange([value.toString()])
            }}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        )}
      </InputGroup>
    </Box>
  )
}
